import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function stretchStyle({ $stretch }: ButtonStyleProps) {
  if ($stretch) {
    return css`
      width: 100%;
      min-width: auto;
      padding-left: 1rem;
      padding-right: 1rem;
    `;
  }
}
